import { observer } from "mobx-react-lite";
import React from "react";
import { TicketMetaField } from "../../../../../administration/ticket_creation/types/field_configs/Meta";
import { TicketMetaFieldType } from "../../../../_shared/types/TicketMeta";
import { BooleanInput } from "./input_types/BooleanInput";
import { DateInput } from "./input_types/DateInput";
import { NumberInput } from "./input_types/NumberInput";
import { SelectInput } from "./input_types/SelectInput";
import { SelectParseInput } from "./input_types/SelectParseInput";
import { StringInput } from "./input_types/StringInput";

type Props = {
  field: TicketMetaField;
  name?: string;
};

const InputComponents: Record<TicketMetaFieldType, React.FC<Props>> = {
  boolean: BooleanInput,
  date: DateInput,
  number: NumberInput,
  select: SelectInput,
  select_parse: SelectParseInput,
  string: StringInput,
};

export const MetaFieldInput = observer((props: Props) => {
  const name = props.field.label?.trim().replace(/\s+/g, "_").toLowerCase();
  const type = props.field.type;

  const Component = InputComponents[type];

  return (
    <>
      <Component field={props.field} name={name} />
    </>
  );
});
